import { createTabCountContext } from '~/components/Offers/Detail/OfferBuilder/shared/createTabCountContext';

import type { PricingToolTab } from './types';

const { Provider, useTabCounts, useTabCount } = createTabCountContext<PricingToolTab>('PricingToolTabCount');

export const PricingToolTabCountProvider = Provider;
export const usePricingToolTabCounts = useTabCounts;
export const usePricingToolTabCount = useTabCount;
